export default __webpack_public_path__ + "static/genopets-banner-0bb13b92f873b93e12395e795f117070.webp";